var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9059 1.00342C15.3724 1.58768 13.6792 1.58768 12.1457 1.00342C5.19629 -1.64953 1.18215 1.03514 0.103289 9.05743C-0.241026 11.5748 0.197976 16.4367 2.58236 16.4367H6.88631L7.90204 19.0319L14.9089 36.9999L21.9329 19.0319L22.9486 16.4367H26.6156C28.4663 16.4367 29.198 11.5662 28.9397 9.05743C28.0101 1.0063 23.9988 -1.67837 16.9059 1.00342ZM19.1612 19.0319L14.9175 29.8889L10.6824 19.0319L9.66666 16.4367H20.1683L19.1612 19.0319ZM23.9558 13.8414H3.07301C2.99449 13.6536 2.93116 13.4598 2.88364 13.2618C2.71621 12.6017 2.61528 11.9265 2.58236 11.2461C2.54653 10.6313 2.5667 10.0146 2.64262 9.40347C2.9525 7.11962 3.68417 4.21291 5.46601 3.10559C6.73137 2.34431 8.65954 2.45678 11.2161 3.42568C13.3382 4.25028 15.6878 4.26259 17.8183 3.46028C20.4437 2.46543 22.415 2.35296 23.6803 3.1229C25.4019 4.18696 26.1077 7.11962 26.3746 9.39482C26.4392 10.0189 26.4392 10.648 26.3746 11.2721C26.303 12.149 26.1178 13.0127 25.8237 13.8414H23.9558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon3);
export default __webpack_public_path__ + "static/media/serviceIcon3.6f5f04c8f39682f58b0f42aa7fcab5c8.svg";
export { ForwardRef as ReactComponent };